// Port of api/fuel/app/classes/filter/search/games/filters/post/collection/group/trade.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'

function buildStatusClause(want, game) {
	if (game) {
		if (want) return '(collection_want = 1 OR collection_wanttobuy = 1 OR collection_wishlist = 1)'
		return '(collection_fortrade = 1)'
	}

	if (want) return '(collection_wantparts = 1)'
	return '(collection_hasparts = 1)'
}

export default {
	name: 'post.collection.group.trade',
	priority: 59,
	post: true,
	require: function(config, filter) {
		return config.ownerType !== F.OWNER_USER && filter.trade && filter.trade.type
	},
	run: function(config, filter, data, results) {
		var userId = config.sessionID || config.userID || 0
		if (!userId || !results.index.length || !data.users || !data.users.length) return results

		var want = filter.trade.status === 'want'
		var game = filter.trade.type === 'games'
		var candidateGames = results.index.slice()
		var wantStatus = buildStatusClause(want, game)
		var haveStatus = buildStatusClause(!want, game)

		var individualRows = DB.query(
			'SELECT DISTINCT game_id FROM collection WHERE user_id = ? AND game_id IN (' + Util.in(candidateGames) + ') AND ' + wantStatus,
			[userId]
		)
		var individualIndex = Util.pluck(individualRows, 'game_id').map(function(id) {
			return parseInt(id, 10)
		}).filter(Boolean)

		if (!individualIndex.length) {
			results.index = []
			return results
		}

		var groupRows = DB.query(
			'SELECT DISTINCT game_id FROM collection WHERE user_id <> ? AND user_id IN (' + Util.in(data.users) + ') AND game_id IN (' + Util.in(individualIndex) + ') AND ' + haveStatus,
			[userId]
		)
		var groupIndex = Util.pluck(groupRows, 'game_id').map(function(id) {
			return parseInt(id, 10)
		}).filter(Boolean)

		if (!groupIndex.length) {
			results.index = []
			return results
		}

		var groupLookup = {}
		for (var i = 0; i < groupIndex.length; i++) groupLookup[groupIndex[i]] = true

		results.index = candidateGames.filter(function(gameId) {
			return groupLookup[gameId]
		})

		return results
	}
}
